import { connect } from "react-redux";
import WalletRequestList from './walletRequestList';
import { bindActionCreators } from "redux";
import {requestApprovalList,walletRequestList} from "services/redux/Wallet/action";


const mapStateToProps = (state) => ({
    approvalListDetails : state.Wallet.approvlListData,
    walletrequestDetails: state.Wallet.walletrequestlist
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        requestApprovalList,
        walletRequestList
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WalletRequestList);